import PropTypes from 'prop-types';
import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import { messages } from './TouModal.i18n';

class TouModal extends React.Component {
  setTitleFocus = () => {
    const foundElems = document.getElementsByClassName('modal-title');
    if (foundElems) {
      foundElems[0].focus();
    }
  }

  render() {
    return (
      <div className="static-modal">
        <Modal show={this.props.show} onHide={this.props.onHide}
          onEntered={ this.setTitleFocus }
        >
          <Modal.Header aria-label="tou" closeButton>
            <Modal.Title data-qa-item="modal-title-tou" tabIndex="0">
              <div>
                <FormattedMessage { ...messages.modal.title } />
              </div>
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <div className="clearfix scrollbox" data-qa-item="modal-text-tou">
              <div dangerouslySetInnerHTML={{ __html: this.props.touContent }}
                tabIndex="0"
              >
              </div>
            </div>
          </Modal.Body>

          <Modal.Footer>
            <Button type="button" className="btn btn-default"
              onClick={ this.props.onHide }
              data-qa-item="modal-close-tou"
              aria-describedby="labelDesc_close"
            >
                <FormattedMessage {...messages.button.close} />
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

TouModal.propTypes = {
  show: PropTypes.bool,
  onHide: PropTypes.func,
  title: PropTypes.object,
  message: PropTypes.object, // array of items to stuff into the message. ['Hi',<div>html</div>,"newrow"]
  id: PropTypes.number,
  touContent: PropTypes.string,
};

export default TouModal;